import {
  signInWithEmailAndPassword,
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
} from 'firebase/auth';
import { Timestamp } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { profileTypes, proprietorTypes } from 'config/types';
import MobxState from './abstract/MobxState';
import { publicAccountDefault } from '../config/dataDefaults';

class AuthState extends MobxState {
  async login(emailAddress, password) {
    const { user } = await signInWithEmailAndPassword(
      getAuth(),
      emailAddress,
      password
    );

    // Send verification request
    this.root.emailVerificationState.sendVerificationRequest(user.email);
  }

  async register(profileFull) {
    const currentSwiftDate = Timestamp.fromDate(new Date());
    const { emailAddress, password, ...restProfile } = profileFull;

    const { user } = await createUserWithEmailAndPassword(
      getAuth(),
      emailAddress,
      password
    );

    const profile = {
      ...restProfile,
      emailAddress,
      profileUid: user.uid,
      fullName: `${profileFull.title} ${profileFull.firstName} ${profileFull.lastName}`,
      dateCreated: currentSwiftDate,
      dateUpdated: currentSwiftDate,
    };

    const publicAccount = {
      ...publicAccountDefault(),
      profileUid: user.uid,
      dateCreated: currentSwiftDate,
      dateUpdated: currentSwiftDate,
      profileType: profile.profileType,
    };

    // Set to company for property manager
    publicAccount.proprietor.type =
      publicAccount.profileType === profileTypes.MANAGER
        ? proprietorTypes.company
        : proprietorTypes.soleTrader;

    publicAccount.appInfo.deviceUid = uuidv4().toUpperCase();
    publicAccount.banking.dateUpdated = currentSwiftDate;
    // publicAccount.stripe.dateCreated = currentSwiftDate;

    await Promise.all([
      this.root.userDataState.profile.update(profile),
      this.root.userDataState.publicAccount.update(publicAccount),
    ]);

    // Send verification request
    this.root.emailVerificationState.sendVerificationRequest(user.email);
  }

  verifyUserPassword(password) {
    return signInWithEmailAndPassword(
      getAuth(),
      getAuth().currentUser.email,
      password
    );
  }

  async deleteProfile() {
    const profile = { ...this.root.userDataState.profile.data };
    profile.dateUpdated = Timestamp.fromDate(new Date());
    profile.hasDeleted = true;
    profile.emailAddress = '';
    profile.title = '';
    profile.firstName = '';
    profile.lastName = '';
    profile.fullName = '';
    profile.mobileNumber = '';

    if (profile.imageUrl) {
      const profileImageRef = ref(getStorage(), profile.imageUrl);
      deleteObject(profileImageRef).catch((e) =>
        console.warn('Failed to delete profile image')
      );
    }

    await this.root.userDataState.profile.update(profile);
    await getAuth().currentUser.delete();

    return this.logout();
  }

  logout() {
    return signOut(getAuth()).then(() =>
      this.root.emailVerificationState.resetVerification()
    );
  }
}

AuthState.annotations = {
  ...MobxState.annotations,
};

export default AuthState;
